<template>
  <PageCardContent
    :class="{
      [$style.wrapper]: true,
      [$style.imagePullLeft]: shouldPlaceImageOnTheLeftSide,
      [$style.imagePullRight]: !shouldPlaceImageOnTheLeftSide,
    }"
    :image="image"
    :content="content"
    :content-class="contentClass"
    :image-class="imageClass"
  />
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import PageCardContent, { PageCardContentProps } from '../components/PageCardContent.ts.vue';

export interface PageTwoColumnsContentProps extends PageCardContentProps {
  imagePullLeft?: boolean;
  imagePullRight?: boolean;
}

export default Vue.extend({
  components: {
    PageCardContent,
  },
  props: {
    image: {
      type: String as PropType<PageTwoColumnsContentProps['image']>,
      required: true,
    },
    content: {
      type: Object as PropType<PageTwoColumnsContentProps['content']>,
      required: true,
    },
    imagePullLeft: {
      type: Boolean as PropType<PageTwoColumnsContentProps['imagePullLeft']>,
      default: true,
    },
    imagePullRight: {
      type: Boolean as PropType<PageTwoColumnsContentProps['imagePullRight']>,
      default: false,
    },
    contentClass: {
      type: [String, Array, Object] as PropType<PageTwoColumnsContentProps['contentClass']>,
      default: undefined,
    },
    imageClass: {
      type: [String, Array, Object] as PropType<PageTwoColumnsContentProps['imageClass']>,
      default: undefined,
    },
  },

  computed: {
    shouldPlaceImageOnTheLeftSide(): boolean {
      if (this.imagePullRight) return false;
      return true;
    },
  },
});
</script>

<style lang="scss" module>
@import '../styles/variables-entry';
@import '../styles/variables';

@include media-breakpoint-up($page-breakpoint-switch) {
  .wrapper {
    align-items: center;
    flex-direction: row;
  }
  .wrapper.imagePullRight {
    flex-direction: row-reverse;
  }
}
</style>
